export default __webpack_public_path__ + "static/media/flag-ceuta.ea6a88ce.svg";